import { idKeys } from './types.ts';

/**
 * Extracts the first identifier key from a templated URL.
 *
 * For example, given `/barge/{bilgePumpId}`, this function
 * will return `"bilgePumpId"`.
 *
 * @param url The URL template to check.
 * @returns The matching {@link IdKey} if found, otherwise `undefined`.
 * @see {@link idKeys} for the full list of supported keys.
 */
export const findIdInUrl = (url: string): string | undefined => {
  for (const key of idKeys) {
    const regex = new RegExp(`{${key}}`);
    if (regex.test(url)) {
      return key;
    }
  }

  return undefined; // No match found
};
